// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes in-btn-social-0b22be33{0%{left:-110%;top:90%}50%{left:10%;top:-30%}100%{top:-10%;left:-10%}}@keyframes out-btn-social-0b22be33{0%{top:-10%;left:-10%}50%{left:10%;top:-30%}100%{left:-110%;top:90%}}.default-layout-wrapper[data-v-0b22be33]{display:flex;flex-direction:column;min-height:100vh}.default-layout-footer[data-v-0b22be33]{margin-top:auto}", ""]);
// Exports
module.exports = exports;
